/**
* Dtails+ Accept terms and conditions
*/

function fnDtailsCartTerms(event, action, status) {
    var cartTerms = event.closest('form').querySelector('dtails-cart-terms');
    if (cartTerms) {
      var cartTermsDrawer = cartTerms.querySelector('[data-dtails-cart-terms-drawer]'),
          orderRecap = document.querySelector('.cart-order__recap');
      if (action == 'open') {
        cartTermsDrawer.classList.add('dtails-cart-terms-drawer--opened');
        if (orderRecap) orderRecap.style.position = "relative";
      } else if (action == 'close') {
        cartTermsDrawer.classList.remove('dtails-cart-terms-drawer--opened');
        if (orderRecap) orderRecap.style.position = "sticky";
      }
  
      if (status == 'accept') {
        var cartTermsDrawerCheckbox = cartTerms.querySelector('[data-dtails-cart-terms-checkbox]');
        if (cartTermsDrawerCheckbox) cartTermsDrawerCheckbox.checked = true;
      }
    }
  }
  
  var DtailsCartTerms = class extends HTMLElement {
    constructor() {
      super();
      document.addEventListener('submit', this._onSubmit);
      this.addEventListener("click", this._onClick);
    }
  
    _onClick(event) {
      if (event.target.closest('[data-dtails-cart-terms-drawer-link]')) {
        fnDtailsCartTerms(event.target, 'open');
        event.preventDefault();
      } else if (event.target.closest('[data-dtails-cart-terms-drawer-close]')) {
        fnDtailsCartTerms(event.target, 'close');
        event.preventDefault();
      } else if (event.target.closest('[data-dtails-cart-terms-accept-button]')) {
        fnDtailsCartTerms(event.target, 'close', 'accept');
        event.preventDefault();
      } else {
        return;
      }
    }
  
    _onSubmit(event) {
      const submit = event.target.querySelector('button');
      const termsCartTerms = submit.closest('form').querySelector('dtails-cart-terms');
      if (!termsCartTerms) return;
  
      const termsCheckbox = termsCartTerms.querySelector('[data-dtails-cart-terms-checkbox]');
  
      if (submit.getAttribute('name') === 'checkout' && termsCheckbox) {
        if (termsCheckbox.checked) {
        } else {
          fnDtailsCartTerms(event.target, 'open');
          submit.setAttribute("aria-busy", "false");
          event.preventDefault();
          return false;
        }
      }
    }
  
  };
  if (!window.customElements.get("dtails-cart-terms") && window.themeVariables.settings.dtailsCartTerms) {
    window.customElements.define("dtails-cart-terms", DtailsCartTerms);
  }
  
  export { DtailsCartTerms };
  